<div class="biz-page">

    <a routerLink="/biz-directory" class="small d-inline-block mb-3">&larr; Business Directory</a>

    <div class="rana-page-header">
        <div>
            <h1 class="rana-page-title">Opportunities</h1>
            <p class="rana-page-subtitle mb-0">Co-founders, hires, suppliers and investors, asked for by RANA members. Posts expire on their own.</p>
        </div>
        <div class="text-right">
            <button class="btn btn-dark-primary" *ngIf="isMember && !formOpen" (click)="openForm()"><i class="uil uil-plus-circle mr-1"></i> Post an opportunity</button>
            <a class="btn btn-dark-primary" *ngIf="!loggedIn" routerLink="/login">Log in to post or reply</a>
            <div class="size-13 text-muted mt-2" *ngIf="loggedIn && !isMember">Only RANA members can post. You can read and reply.</div>
        </div>
    </div>

    <!-- New post -->
    <form class="rana-panel mt-3" *ngIf="formOpen" (ngSubmit)="post()">
        <div class="row">
            <div class="col-md-4 mb-3">
                <label class="font-weight-600 size-14">I am looking for *</label>
                <select class="form-style with-border" name="type" [(ngModel)]="draft.type">
                    <option *ngFor="let t of types" [value]="t.value">{{ t.label }}</option>
                </select>
            </div>
            <div class="col-md-8 mb-3">
                <label class="font-weight-600 size-14">Title *</label>
                <input type="text" class="form-style with-border" name="title" maxlength="120" [(ngModel)]="draft.title" placeholder="e.g. Looking for a baker to join our new shop">
            </div>
            <div class="col-12 mb-3">
                <label class="font-weight-600 size-14">Details *</label>
                <textarea class="form-control" rows="4" name="description" maxlength="1500" [(ngModel)]="draft.description"
                          placeholder="What you need, where, and how to start the conversation"></textarea>
            </div>
            <div class="col-md-3 mb-3">
                <label class="font-weight-600 size-14">City</label>
                <input type="text" class="form-style with-border" name="city" maxlength="80" [(ngModel)]="draft.city">
            </div>
            <div class="col-md-3 mb-3">
                <label class="font-weight-600 size-14">State</label>
                <select class="form-style with-border" name="state" [(ngModel)]="draft.state">
                    <option value="">Any</option>
                    <option *ngFor="let s of states" [value]="s.code">{{ s.name }}</option>
                </select>
            </div>
            <div class="col-md-3 mb-3">
                <label class="font-weight-600 size-14">About my business</label>
                <select class="form-style with-border" name="businessId" [(ngModel)]="draft.businessId">
                    <option value="">Not linked</option>
                    <option *ngFor="let b of myBusinesses" [value]="b.id">{{ b.businessName }}</option>
                </select>
            </div>
            <div class="col-md-3 mb-3">
                <label class="font-weight-600 size-14">Keep it up for</label>
                <select class="form-style with-border" name="durationDays" [(ngModel)]="draft.durationDays">
                    <option [ngValue]="30">30 days</option>
                    <option [ngValue]="60">60 days</option>
                    <option [ngValue]="90">90 days</option>
                </select>
            </div>
        </div>
        <button type="submit" class="btn btn-dark-primary mr-2">Publish</button>
        <button type="button" class="rana-action-btn" (click)="formOpen = false">Cancel</button>
    </form>

    <!-- Filters -->
    <div class="mt-4">
        <input type="text" class="form-style big with-border mb-2" placeholder="Search opportunities" [(ngModel)]="q" (keyup.enter)="load()" (blur)="load()">
        <div class="opp-chips">
            <button type="button" class="opp-chip" *ngFor="let t of types" [class.active]="typeFilter === t.value" (click)="pickType(t.value)">{{ t.label }}</button>
        </div>
    </div>

    <div *ngIf="loading && !loaded" class="text-muted py-4">Loading…</div>
    <div *ngIf="loaded && !items.length" class="rana-panel text-center py-5 mt-3">
        <i class="uil uil-megaphone size-40 color-primary mb-2 d-block"></i>
        <strong class="d-block mb-1">No open opportunities right now.</strong>
        <p class="mb-0 text-muted">Members can post what they are looking for, and it appears here.</p>
    </div>

    <div class="opp-card" *ngFor="let o of items" [class.hidden-post]="o.status === 'HIDDEN'">
        <div class="d-flex flex-wrap align-items-center mb-1">
            <span class="rana-badge rana-badge-accent mr-2">{{ typeLabel(o.type) }}</span>
            <span class="size-13 text-muted">
                <span *ngIf="o.city || o.state"><i class="uil uil-map-marker"></i> {{ [o.city, o.state].filter(hasText).join(', ') }} &middot; </span>
                posted {{ o.createdAtEpoch | date:'mediumDate' }} &middot; {{ daysLeft(o) }} day{{ daysLeft(o) === 1 ? '' : 's' }} left
            </span>
        </div>
        <h5 class="mb-1">{{ o.title }}</h5>
        <p class="opp-text mb-2">{{ o.description }}</p>
        <div class="size-13 text-muted mb-2">
            By {{ o.authorName }}
            <span *ngIf="o.businessId"> &middot; <a [routerLink]="['/biz-directory', o.businessId]">{{ o.businessName }}</a></span>
        </div>
        <div class="alert alert-warning py-1 size-13" *ngIf="o.status === 'HIDDEN'">Hidden from everyone else. <span *ngIf="o.hiddenReason">Reason: {{ o.hiddenReason }}</span></div>

        <button type="button" class="rana-action-btn mr-2" *ngIf="o.authorId !== userId" (click)="reply(o)"><i class="uil uil-message"></i> Reply</button>
        <button type="button" class="rana-action-btn mr-2" *ngIf="o.canModerate" (click)="toggleHidden(o)">{{ o.status === 'HIDDEN' ? 'Unhide' : 'Hide' }}</button>
        <button type="button" class="rana-action-btn rana-action-btn-danger" *ngIf="o.canEdit || o.canModerate" (click)="remove(o)">Delete</button>

        <div class="mt-2" *ngIf="replyingTo === o.opportunityId">
            <p class="size-13 text-muted mb-1">Your name and email are shared with {{ o.authorName }} so they can reply.</p>
            <textarea class="form-control mb-2" rows="3" maxlength="2000" [(ngModel)]="replyText" placeholder="Introduce yourself and say how you can help"></textarea>
            <button type="button" class="btn btn-dark-primary mr-2" [disabled]="replyText.trim().length < 10" (click)="sendReply(o)">Send</button>
            <button type="button" class="rana-action-btn" (click)="replyingTo = null">Cancel</button>
        </div>
    </div>
</div>
